<template>
<div class="Quotation">
  <!-- 模板1、2 -->
  <div v-if="template==1||template==2" :class="'temp-'+template" class="pt5">
    <div class="fs7 font-bold">{{item.name}}</div>
    <div class="fs4 pb2">销售清单</div>
    <div v-if="template==1" class="row align-self-center justify-content-between font-bold pl2 pr2 fs5">
      <div><span style="letter-spacing: 5px;">客户</span><span class="pl1">{{item.customer||''}}</span></div>
      <div>
        <template v-if="queryDateString">{{queryDateString}}</template>
        <template v-else>年<span class="pl7">月</span><span class="pl7">日</span></template>
      </div>
    </div>
    <table class="fs5">
      <thead v-if="pageType==='bill' || (item.quotes && item.quotes.length > 0)">
        <tr>
          <th>行话</th>
          <th>
            <span v-if="QUOTE_SECTION[item.section]" class="fc-red">{{QUOTE_SECTION[item.section]}}</span>
            <span v-else>规格</span>
            <span class="fs1">{{item.unitText?'(':''}}{{item.unitText}}{{item.unitText?')':''}}</span>
          </th>
          <th width="25%">单价
            <!-- <span class="fs1">(元/斤)</span> -->
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(quo, qindex) in item.quotes" :key="qindex">
          <td>{{quo.categoryText||''}}</td>
          <td>{{quo.weightText||''}}</td>
          <td><div>{{quo.tPrice||''}}</div></td>
        </tr>
      </tbody>
    </table>
    <div class="row align-items-center pl3 pt5 pb2">
      <div class="flex-1 text-left fs2 font-bold pr9 pb1">
        <div class="row-border pr1 pt1 row align-items-end">
          <div class="row-label">主营</div>
          <div class="flex-1 pl5">{{item.mainProducts}}</div>
        </div>
        <div class="row-border pr1 pt1 row align-items-end">
          <div class="row-label">联系方式</div>
          <div class="flex-1 pl5">
            <div v-for="(mo) in item.mobileList"
              :key="mo.mobile"
            >
              <span class="pr1">{{mo.name}}</span>
              <a class="pl1 pr1"
              :href="'tel:'+(mo.mobile || '')">{{mo.mobile || ''}}</a>
            </div>
          </div>
        </div>
        <div class="row-border pr1 pt1 row align-items-end">
          <div class="row-label">联系地址</div>
          <div class="flex-1 pl5">{{item.address}}</div>
        </div>
        <div v-if="item.describe" class="row-border pr1 pt1 row align-items-end">
          <div class="row-label">备注</div>
          <div class="flex-1 pl5">{{item.describe}}</div>
        </div>
      </div>
      <img v-if="item.qrcodeUrl" :src="item.qrcodeUrl" width="75" height="75">
      <!-- <div v-else class="wechat-header">
        <div class="header">微信二维码</div>
      </div> -->
    </div>
  </div>
  <!-- 模板3 -->
  <template v-else>
    <div v-if="item.createDate" class="text-left fs4 fc-red-cus">{{handleUpdateTime(item.createDate).updateTimeStr}}更新</div>
    <div class="bc-white over-hidden item-box">
      <!-- <div v-if="item.priceType" class="price-tag">
        <img class="price-tag-bg" src="../assets/price_arc.png">
        <div class="price-tag-text" :style="{'font-size': item.priceType&&item.priceType.length>3?'12px':''}">{{item.priceType}}</div>
      </div> -->
      <!-- <div class="guarantee-tag">
        <div>担保金</div>
        <div>{{item.guarantee}}</div>
      </div> -->
      <div class="bc-title fc-white pt2 pb2 pos-rel quotation-title">
        <div v-if="item.priceType" class="price-tag-text row align-items-center justify-content-center" :style="{'font-size': item.priceType&&item.priceType.length>4?'13px':''}">{{item.priceType}}</div>
        <div class="ff-bold fs7 merchant-name">{{item.address}}</div>
        <div class="fs6">{{item.name}}</div>
      </div>
      <div v-if="item.quotes && item.quotes.length > 0"
        class="row item font-bold fs6 bc-tr fc-white">
        <div class="col">行话</div>
        <div :class="QUOTE_SECTION[item.section] ? 'col quote-section' : 'col'">
          <div v-if="QUOTE_SECTION[item.section]" class="fc-red">{{QUOTE_SECTION[item.section]}}</div>
          <div v-else>规格</div>
          <div class="fs1 quote-unit">{{item.unitText?'(':''}}{{item.unitText}}{{item.unitText?')':''}}</div>
        </div>
        <div class="col">
          <div>{{queryDateString||'价格'}}</div>
          <div class="fs1">(元/斤)</div>
        </div>
        <!-- <div class="col">昨天</div> -->
        <div v-if="pageType==='quotaion'" class="col">
          <div>同比昨天</div>
          <div class="fs1">(元/斤)</div>
        </div>
      </div>
      <div v-for="(quo, qindex) in item.quotes"
        :key="qindex">
        <div class="row line-top item fs7">
          <div class="col" :class="quo.categoryText && quo.categoryText.length>5?'fs4':''">{{quo.categoryText}}</div>
          <div class="col">{{quo.weightText||''}}</div>
          <div class="col">{{quo.tPrice||''}}</div>
          <!-- <div class="col">{{quo.yPrice||'-'}}</div> -->
          <div v-if="pageType==='quotaion'" class="col">
            <span class="fc-suppl" v-if="!quo.yPrice">
              昨天没报
            </span>
            <div class="row align-items-center justify-content-center" v-else-if="(quo.tPrice || 0) > (quo.yPrice || 0)">
              <span class="price-status bc-red">涨</span>
              <span class="pl1 fc-danger">{{((quo.tPrice || 0) - (quo.yPrice || 0)).toFixed(1)}}</span>
            </div>
            <template v-else-if="(quo.tPrice || 0) == (quo.yPrice || 0)">
              <span class="pl1">平</span>
            </template>
            <div class="row align-items-center justify-content-center" v-else>
              <span class="price-status bc-blue">跌</span>
              <span class="pl1 fc-blue">{{((quo.yPrice || 0) - (quo.tPrice || 0)).toFixed(1)}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="bc-primary-info text-left padding2 row align-items-center fs5 fc-dark">
        <div class="flex-1">
          <template v-if="pageType==='bill'">
            <div><span class="pl2">备注：</span>{{item.describe}}</div>
            <!-- <div><span class="pl2">发布时间：</span>{{item.createDate}}</div> -->
            <div><span class="pl2">最近一次报价时间：</span>{{handleUpdateTime(item.createDate).publishTimeStr}}</div>
          </template>
          <template v-else>
            <div><span class="pl2">运费：</span>{{item.info1}}</div>
            <div><span class="pl2">死亡：</span>{{item.info2}}</div>
            <div><span v-if="item.describe" class="pl2">备注：</span>{{item.describe}}</div>
            <div><span v-if="item.adSlogan" class="pl2">宣传语：</span>{{item.adSlogan}}</div>
            <!-- <div><span class="pl2">发布时间：</span>{{item.createDate}}</div> -->
            <!-- <div><span class="pl2">最近一次报价时间：</span>{{handleUpdateTime(item.createDate).publishTimeStr}}</div> -->

          </template>
        </div>
      </div>
      <div class="bc-red font-bold fc-white row justify-content-center align-items-center">
        <div class="col-24 row justify-content-center align-items-center pt2 pb2">
          <van-icon name="phone" size="16" />
          <div v-for="(mo, moindex) in item.mobileList"
            :key="mo.mobile"
          >
            <template v-if="moindex!==0">/</template>
            <span class="pl1">{{mo.name}}</span>
            <a class="pl1 pr1 fc-white fs6"
            :href="'tel:'+(mo.mobile || '')">{{mo.mobile || ''}}</a>
          </div>
        </div>
        <div @click="previewImage(item.qrcodeUrl, 0)"  v-if="item.qrcodeUrl&&(!$route.meta||!$route.meta.hideQrcode)" class="col-12 text-center pb3">
          <img v-if="pageType==='bill'" :src="item.qrcodeUrl" width="100" height="100" style="border-radius: 4px">
          <img v-else :src="fileDomain+item.qrcodeUrl" width="100" height="100" style="border-radius: 4px">
          <div class="text-center fs8">扫码加微信</div>
        </div>
        <div @click="previewImage(item.miniQrCode, 1)"  v-if="item.miniQrCode&&(!$route.meta||!$route.meta.hideQrcode)" class="col-12 text-center pb3">
          <img v-if="pageType==='bill'" :src="item.miniQrCode" width="100" height="100" style="border-radius: 4px">
          <img v-else :src="fileDomain+item.miniQrCode" width="100" height="100" style="border-radius: 4px">
          <div class="text-center fs8">扫码看门店</div>
        </div>
      </div>
    </div>
  </template>
    <!-- 图片预览弹框 -->
    <van-popup
      v-model="previewShow"
      position="bottom"
    >
      <div class="pb10 pl2 pr2">
        <van-image
          width="100%"
          height="60vh"
          fit="contain"
          :src="priviewQrcodeUrl"
        >
          <template v-slot:loading>
            图片加载中<van-loading type="spinner" size="20" />
          </template>
        </van-image>
        <van-icon class="mt7"
          @click="previewImage('')"
          :size="36" color="#fff" name="close" />
        <div class="text-center mt10 pb10 fc-white fs10">
          长按图片识别二维码{{previewType === 1 ?'看门店':'加微信'}}
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import { QUOTE_SECTION } from '@/uitls/const';
import config from '../config';

export default Vue.extend({
  name: 'Quotation',
  components: {},
  data() {
    return {
      QUOTE_SECTION,
      previewShow: false,
      previewType: 0,
      fileDomain: config.FILE_DOMAIN,
      priviewQrcodeUrl: '',
    };
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    queryDateString: {
      type: String,
      default: '',
    },
    template: {
      type: String,
      default: '3',
    },
    pageType: { // 页面类型 quotaion--正常报价页面；bill--报价单小工具;
      type: String,
      default: 'quotaion',
    },
  },
  computed: {
  },
  methods: {
    handleUpdateTime(dateStr) {
      if (!dateStr) {
        return '';
      }
      // eslint-disable-next-line no-underscore-dangle
      const _dateStr = dateStr.replaceAll('-', '/');
      const [year, month, day, hour, min] = new Date(_dateStr).toLocaleString('zh-cn', { hour12: false }).split(/[/ :]/);
      const [currentYear, currentMonth, currentDay] = new Date().toLocaleDateString().split('/');
      let str = `${month}月${day}`;
      // 如果是当天
      if (year === currentYear && month === currentMonth && day === currentDay) {
        str = '今天';
      }
      const updateTimeStr = `${str} ${hour}:${min}`;
      const publishTimeStr = `${year}年${month}月${day}日`;
      return {
        updateTimeStr,
        publishTimeStr,
      };
    },
    previewImage(url, type) {
      this.previewShow = !this.previewShow;
      this.priviewQrcodeUrl = url.includes('http') ? url : `${this.fileDomain}${url}`;
      this.previewType = type;
    },
    imgLoaded() {
      this.$emit('load', true);
    },
    imgError() {
      this.$emit('load', false);
    },
  },
  created() {
  },
});
</script>
<style scoped>
.Quotation {
  /* width: 100vw; */
  /* background-color: #ffffff; */
}
  /* 模板1 */
  .temp-1 {
    color: #e33b4f;
    padding: 10px 8px 5px 8px;
    background-color: #e7e6ff;
  }
  .temp-1 table {
    border-top: 1px solid #e33b4f;
    border-left: 1px solid #e33b4f;
    border-bottom: 1px solid #e33b4f;
    width: 100%;
    border-spacing: 0;
  }
  .temp-1 .row-border {
    border-bottom: 1px solid #e33b4f;
  }
  .temp-1 table th{
    padding: 3px 1px;
    border-right: 1px solid #e33b4f;
  }
  .temp-1 table td{
    padding: 3px 1px;
    border-top: 1px solid #e33b4f;
    border-right: 1px solid #e33b4f;
  }
  .temp-1 table td div{
    min-height: 23px;
  }
  .wechat-header{
    background-color: #ffffff;
    padding: 3px;
    width: 76px;
    height: 76px;
  }
  .header{
    border: 1px solid #0e3a5f;
    color: #232323;
    height: 100%;
    font-size: 12px;
    line-height: 70px;
    font-weight: bold;
  }
  .temp-1 .row-label{
    width: 60px;
  }
  .temp-1 a {
    color: #e33b4f;
  }
  .temp-2 a {
    color: #000000;
  }
  /* 模板1 */
  .temp-2 {
    color: #000000;
    padding: 10px 8px 5px 8px;
    background-color: #e7e6ff;
  }
  .temp-2 table {
    width: 100%;
    border-spacing: 0;
  }
  .temp-2 .row-border {
    border-bottom: 1px solid #000000;
  }
  .temp-2 table th{
    padding: 3px 1px;
    border-top: 1px solid #000000;
  }
  .temp-2 table td{
    padding: 3px 1px;
  }
  .temp-2 table td div{
    min-height: 23px;
  }
  .temp-2 .row-label{
    width: 60px;
  }
  /* 模板3 */
  .fc-quotation {
    color: #0e3a5f;
  }
  .item-box {
    position: relative;
    color: #0e3a5f;
    box-shadow: 0px 4px 6px #7d7979;
    border-radius: 16px;
    border: 2px solid #1e67c7;
  }
  .guarantee-tag {
    position: absolute;
    right: 15px;
    top: 0;
    /* background-color: #621f70; */
    color: white;
    font-size: 12px;
    padding: 4px 5px 12px;
    background-image: url('../assets/guarantee_tag.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .quotation-title {
    padding-left: 65px;
    padding-right: 5px;
  }
  .price-tag {
    position: absolute;
    left: 0;
    top: 0;
    /* background-color: #b8d0f2; */
    /* color: #1e67c7; */
    width: 76px;
    height: 35px;
    z-index: 1;
  }
  .price-tag-bg {
    width: 100%;
  }
  .price-tag-text {
    position: absolute;
    top: 0;
    left: 0;
    width: 70px;
    /* padding-top: 5px; */
    /* padding-right: 10px; */
    text-align: center;
    font-weight: 600;
    font-size: 16px;
    background: rgba(255, 255, 0, 1);
    /* border: 1px solid #0e3a5f; */
    border-top-left-radius: 16px;
    color: red;
    height: 100%;
    /* padding: 10px; */
    vertical-align: middle;
  }
  .line-top {
    border-top: 2px solid #1e67c7;
  }
  .line-bottom {
    border-bottom: 1px solid #e6e1e1;
  }
  .line-left {
    border-left: 1px solid #e6e1e1;
  }
  .item .col {
    padding-top: 2px;
    padding-bottom: 2px;
    padding-left: 1px;
    min-height: 26px;
  }
  .refresh {
    position: fixed;
    bottom: 20vh;
    right: 5px;
    width: 36px;
    height: 36px;
    line-height: 36px;
    border-radius: 50%;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.5);
    color: #ffffff;
  }
  .backtop {
    bottom: calc(20vh - 50px);
  }
  /* .quotation-icon {
    width: 30px;
    height: 30px;
  } */
  .notice-fixed-top {
    position: fixed;
    top: 0;
    left: 0;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    z-index: 999;
  }
  .notice-fixed-height {
    padding: 0 5px 2px 5px;
    width: 100%;
    font-size: .8rem;
    /* margin: 0 auto; */
  }
  .notice-place-holder {
    opacity: 0;
  }
  .bottombtn {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: #ece8e8;
    /* padding: 4px; */
    box-shadow: 1px -2px 6px #7d7979;
  }
  .bottombtn-height {
    height: 46px;
  }
  .bottom-btn {
    line-height: 1;
    font-size: 14px;
  }
  .bottom-btn button {
    margin: 0;
  }
  .fc-suppl {
    color: #1e67c7;
  }
  .bc-title {
    background-color: #1e67c7;
  }
  .bc-tr {
    background-color: #0e3a5f;
  }
  .merchant-name {
    /* padding-left: 65px; */
    padding-right: 10px;
  }
  .fc-danger {
    color: #b71831!important;
  }
  .fc-red {
    color: red!important;
  }
  .bc-red {
    background-color: #b71831!important;
  }
  .bc-blue {
    background-color: #00bcd4!important;
  }
  .fc-blue {
    color: #00bcd4!important;
  }
  .quote-section {
    background: rgba(255, 255, 0, 1);
    border-radius: 6px;
    .quote-unit {
      color: #000000;
    }
  }
  .price-status {
    color: #ffffff;
    border-radius: 4px;
    font-size: 13px;
    text-align: center;
    line-height: 18px;
    width: 19px;
    height: 19px;
  }
  .van-popup {
    background-color: transparent;
  }
</style>
